<script setup lang="ts">
import type { AvatarImageProps } from 'reka-ui';
import { AvatarImage } from 'reka-ui';

const props = defineProps<AvatarImageProps>();
</script>

<template>
    <AvatarImage
        data-slot="avatar-image"
        v-bind="props"
        class="aspect-square size-full h-full w-full rounded-[inherit] object-cover"
    >
        <slot />
    </AvatarImage>
</template>
